import PropTypes from 'prop-types';
import ImmutablePropTypes from 'react-immutable-proptypes';

export const Cohort = PropTypes.shape({
  createdBy: PropTypes.string,
  id: PropTypes.string.isRequired,
  lastUpdatedOn: PropTypes.string.isRequired,
  path: PropTypes.string.isRequired,
  coursePath: PropTypes.string.isRequired,
  title: PropTypes.string.isRequired,
  url: PropTypes.string.isRequired,
});

export const ImmutableCohort = ImmutablePropTypes.mapContains({
  createdBy: PropTypes.string,
  id: PropTypes.string.isRequired,
  lastUpdatedOn: PropTypes.string.isRequired,
  path: PropTypes.string.isRequired,
  coursePath: PropTypes.string.isRequired,
  title: PropTypes.string.isRequired,
  url: PropTypes.string.isRequired,
});
